<template>
  <div class="manual-transaction-limits">
    <v-data-table
      v-if="!isLoading"
      :headers="headers"
      :items="manualTransactionLimits"
      hide-default-footer
      disable-pagination
      height="calc(100vh - 48px)"
    >
      <template #body.prepend>
        <manual-transaction-limits-editor
          v-if="isAddingNewItem"
          :transactionLimit="getEmptyTransactionLimit()"
          :entities-by-id="entitiesById"
          @save="$emit('save', $event)"
          @close="isAddingNewItem = false"
        />
      </template>
      <template #item="{item}">
        <component
          :is="getItemComponent(item)"
          :transaction-limit="item"
          :entities-by-id="entitiesById"
          @edit="limitIdToEdit = item.transaction_limit_id"
          @save="$emit('save', $event)"
          @close="limitIdToEdit = null"
          @delete="$emit('delete', item.transaction_limit_id)"
        />
      </template>
      <template #header.action>
        <v-icon @click="isAddingNewItem = true">
          add
        </v-icon>
      </template>
    </v-data-table>
    <v-progress-circular v-else indeterminate />
  </div>
</template>

<script>
import ManualTransactionLimitsView from './ManualTransactionLimitsView.vue';
import ManualTransactionLimitsEditor from './ManualTransactionLimitsEditor.vue';

export default {
  components: {
    ManualTransactionLimitsEditor,
    ManualTransactionLimitsView
  },
  props: {
    manualTransactionLimits: {
      type: Array,
      default: () => ([])
    },
    entitiesById: {
      type: Object,
      default: () => ({})
    },
    isLoading: Boolean
  },
  data() {
    return {
      headers: [
        { text: '#', value: 'transaction_limit_id', sortable: false },
        { text: 'Project', value: 'entity_id' },
        { text: 'Type', value: 'type' },
        { text: 'Min', value: 'min_limit' },
        { text: 'Max', value: 'max_limit' },
        { text: 'Daily', value: 'daily_limit' },
        { text: 'Weekly', value: 'weekly_limit' },
        { text: 'Monthly', value: 'monthly_limit' },
        { text: '', value: 'action', sortable: false },
      ],
      limitIdToEdit: null,
      isAddingNewItem: false
    }
  },
  emits: ['save'],
  methods: {
    getItemComponent(item) {
      return item.transaction_limit_id === this.limitIdToEdit ? ManualTransactionLimitsEditor : ManualTransactionLimitsView;
    },
    getEmptyTransactionLimit() {
      return {
        daily_limit: 0,
        max_limit: 0,
        min_limit: 0,
        monthly_limit: 0,
        weekly_limit: 0
      }
    }
  },

  watch: {
    isLoading(newValue, oldValue) {
      if (oldValue && !newValue) {
        this.limitIdToEdit = null;
        this.isAddingNewItem = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
